module.exports = __webpack_public_path__ + "img/city-projects.c4d3e997.jpeg";